var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 17.3337H3.83333C2.91286 17.3337 2.16667 16.5875 2.16667 15.667V4.83366H0.5V3.16699H3.83333V2.33366C3.83333 1.41318 4.57953 0.666992 5.5 0.666992H10.5C11.4205 0.666992 12.1667 1.41318 12.1667 2.33366V3.16699H15.5V4.83366H13.8333V15.667C13.8333 16.5875 13.0871 17.3337 12.1667 17.3337ZM3.83333 4.83366V15.667H12.1667V4.83366H3.83333ZM5.5 2.33366V3.16699H10.5V2.33366H5.5ZM10.5 14.0003H8.83333V6.50033H10.5V14.0003ZM7.16667 14.0003H5.5V6.50033H7.16667V14.0003Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMedia);
export default __webpack_public_path__ + "static/media/deleteMedia.1125f6740e01d5c5275805da79773868.svg";
export { ForwardRef as ReactComponent };